
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/system-design-interview",
      function () {
        return require("private-next-pages/books/system-design-interview.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/system-design-interview"])
      });
    }
  